import addClasses from '../../../../utils/addClasses';

export default function createAnchorElement(linkConfig) {
  const anchor = document.createElement('a');
  anchor.setAttribute('href', linkConfig.href);
  anchor.innerHTML = linkConfig.linkText;
  addClasses(anchor, linkConfig.classList);

  return anchor;
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/createElements/createAnchorElement.js